import React, { useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';

interface PublicRouteProps {
  children: React.ReactNode;
}

/**
 * Public Route Component
 * Redirects to POS if already authenticated
 */
export const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  useEffect(() => {
    // Use full page navigation for cross-app routing (POS app is separate)
    if (!loading && isAuthenticated) {
      window.location.href = '/pos';
    }
  }, [isAuthenticated, loading]);
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="flex items-center space-x-2">
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
          <span className="text-gray-600">Loading...</span>
        </div>
      </div>
    );
  }
  
  // If authenticated, redirect will happen via useEffect
  if (isAuthenticated) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="flex items-center space-x-2">
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
          <span className="text-gray-600">Redirecting...</span>
        </div>
      </div>
    );
  }
  
  return <>{children}</>;
};











